import { styled } from '@mui/material/styles';

/** Small grey pill pinned to the top-right corner of a `position: relative` parent. */
export const CornerBadge = styled('span')(({ theme }) => ({
  position: 'absolute',
  top: 4,
  right: 8,
  zIndex: 1,
  padding: '2px 6px',
  borderRadius: Number(theme.shape.borderRadius) * 2.5,
  backgroundColor: theme.palette.grey[600],
  color: theme.palette.common.white,
  fontSize: 10,
  fontWeight: theme.typography.fontWeightBold,
}));
